import dynamic from 'next/dynamic'

export const SectionOfPressBanners = dynamic(
    () => import('./section-of-press-banners'),
)
